import { render, staticRenderFns } from "./IroningOnlyIcon.vue?vue&type=template&id=0bb65774&"
import script from "./IroningOnlyIcon.vue?vue&type=script&lang=js&"
export * from "./IroningOnlyIcon.vue?vue&type=script&lang=js&"
import style0 from "./IroningOnlyIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports